import { DevelopersContainer } from './DevelopersContainer';

const name = 'DevelopersContainer';

export { DevelopersContainer, name };
